import { render, staticRenderFns } from "./DrugInfo.vue?vue&type=template&id=01ad49ee"
import script from "./DrugInfo.vue?vue&type=script&lang=js"
export * from "./DrugInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports